module.exports = __webpack_public_path__ + "fonts/iconfont.1962fc0b.ttf";